module.exports = __webpack_public_path__ + "assets/log.2eee877a.svg";